import { displayTimeToPercent, } from "ui/components/elements/chart/chart-timeline";
// How much the PS/ES zoom window is extended past part secured and energy
// saving, as a share of the time up to them, so the user also sees a bit of
// what happens next.
var PS_ES_ZOOM_TRAILING_FRACTION = 0.25;
/**
 * The default zoom: from the start of the cycle until every cup has reached
 * part secured and energy saving has started, plus another 25 % of that time,
 * or until every cup has levelled out (`cupsSettledTimes`, Recharts time),
 * whichever is later. A levelled-out curve needs no time after it, so the zoom
 * ends right there. Neither goes past the release, so a cup still building up
 * vacuum when the part is placed doesn't make the zoom pointless.
 */
export var computePsEsZoomTimes = function (timeline, cupsSettledTimes) {
    var _a, _b;
    var toTimelineTime = function (time) {
        return time === undefined
            ? 0
            : displayTimeToPercent(time, timeline) * timeline.totalTime;
    };
    var capAtRelease = function (time) { return Math.min(time, timeline.transfer.end); };
    var partSecuredTime = capAtRelease(Math.max(timeline.timeToPartSecured.end, (_b = (_a = timeline.timeWithEnergySavingOn) === null || _a === void 0 ? void 0 : _a.begin) !== null && _b !== void 0 ? _b : 0, toTimelineTime(cupsSettledTimes.partSecured)));
    var levelledOutTime = capAtRelease(toTimelineTime(cupsSettledTimes.levelledOut));
    return {
        startTime: 0,
        endTime: Math.max(partSecuredTime * (1 + PS_ES_ZOOM_TRAILING_FRACTION), levelledOutTime),
    };
};
export var computeAtmZoomTimes = function (timeline) {
    var start = timeline.releaseTimeToPlacePart.begin;
    var end = timeline.additionalReleaseTime.end;
    var duration = end - start;
    var padding = duration * 0.125;
    return {
        startTime: Math.max(0, start - padding),
        endTime: Math.min(timeline.totalTime, end + padding),
    };
};
var containsTime = function (_a, time) {
    var startTime = _a.startTime, endTime = _a.endTime;
    return time >= startTime && time <= endTime;
};
var rangesAlmostEqual = function (a, b) {
    return Math.abs(a.startTime - b.startTime) < 0.001 &&
        Math.abs(a.endTime - b.endTime) < 0.001;
};
var crossedIntoTime = function (previousRange, newRange, time) { return !containsTime(previousRange, time) && containsTime(newRange, time); };
export var getPresetZoomForDraggedRange = function (_a) {
    var timeline = _a.timeline, cupsSettledTimes = _a.cupsSettledTimes, previousRange = _a.previousRange, newRange = _a.newRange, dragType = _a.dragType;
    if (dragType !== "body")
        return;
    if (crossedIntoTime(previousRange, newRange, timeline.releaseTimeToPlacePart.begin)) {
        var atmRange = computeAtmZoomTimes(timeline);
        return rangesAlmostEqual(previousRange, atmRange) ? undefined : atmRange;
    }
    if (crossedIntoTime(previousRange, newRange, timeline.timeToPartSecured.end)) {
        var psEsRange = computePsEsZoomTimes(timeline, cupsSettledTimes);
        return rangesAlmostEqual(previousRange, psEsRange) ? undefined : psEsRange;
    }
    return undefined;
};
